// TODO move to file provider services
export const FacebookDataProviderItemType: string = 'FacebookDataProviderItem:#Exchange';
export const FacebookProviderScopeType: string = 'FacebookProviderScope:#Exchange'; // use in fh
export const FileAttachmentDataProviderItemType: string =
    'FileAttachmentDataProviderItem:#Exchange';
export const FolderAttachmentDataProviderItemType: string =
    'FolderAttachmentDataProviderItem:#Exchange';
export const GDriveDataProviderItemType: string = 'GDriveDataProviderItem:#Exchange';
export const OneDriveProScopeName: string = 'OneDriveProScope:#Exchange';
export const ScopeBreadcrumbId: string = 'scopeId';
export const SearchBreadcrumbId: string = 'searchId';
export const SizeLimitInKbToSuggestSharing: number = 5 * 1024;
